import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { useToast } from "../../controller/ToastController";
import { adverState } from "../../recoil/adver";
import {
  authState,
  authStoreType,
  authType,
  masterStoreState,
} from "../../recoil/auth";
import { getDecryptObject } from "../../utils/crypto";
import { APP_TYPE } from "../../utils/DataType";

const Login = () => {
  const showToast = useToast();
  const navigate = useNavigate();

  const [auth, setAuth] = useRecoilState<authType>(authState);
  const [master, setMaster] = useRecoilState<authStoreType | null>(
    masterStoreState
  );
  const [id, setId] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [adverFlag, setAdverFlag] = useRecoilState<boolean>(adverState);

  const navigateMaster = () => {
    document.removeEventListener("message", handleAuth);
    navigate(`/`);
    setAdverFlag(true);
  };

  const login = async () => {
    let response = await ApiController.auth.signin({
      id,
      password,
      device_uuid: "test",
      app_type: APP_TYPE.KNOCK,
      version: "",
    });

    if (
      response.data === undefined ||
      response.data.ok === false ||
      response.data.data === undefined
    ) {
      showToast(`아이디또는 비밀번호가 잘못되었습니다.`, "error");
      return false;
    }

    let loginInfo: authType = response.data.data;
    const store_list = loginInfo.store_list.filter(
      (a: any) => a.store_type === 4
    );

    if (store_list.length === 0) {
      showToast(`호텔 매장 등록이 필요합니다.`, "error");
      return false;
    }

    showToast(`user_token_id:[${loginInfo.user_token_id}]`);
    setAuth(loginInfo);
    setMaster(store_list[0]);
    // getEnv(loginInfo.user_token_id);
    localStorage.setItem("auth", JSON.stringify(loginInfo));

    navigateMaster();
  };

  const handleAuth = (event: any) => {
    let message = getDecryptObject(event.data);

    if (message.type === "set_auth") {
      setAuth(message.data);
      setMaster(
        message.data.store_list.filter((a: any) => a.store_type === 4)[0]
      );
    }
  };
  document.addEventListener("message", handleAuth);

  return (
    <Style>
      <div className="knockContainer">
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/img/logo.png`}
          width={190}
          alt="노크노크로고"
          className="logo"
        />
        <input
          className="loginInput"
          type="text"
          placeholder="아이디 입력"
          value={id}
          onChange={(e: any) => setId(e.target.value)}
        />
        <input
          className="loginInput"
          type="password"
          placeholder="비밀번호 입력"
          value={password}
          onChange={(e: any) => setPassword(e.target.value)}
        />

        <button onClick={login}>로그인</button>
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/img/qrcode.png`}
          width={129}
          alt="고객센터연결 QR코드"
          className="qrCodeImage"
        />
      </div>
    </Style>
  );
};
export default Login;

const Style = styled.div`
  .knockContainer {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    padding: 0 15vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #000000;
  }
  .logo {
    margin-bottom: 115px;
  }

  /* login */
  .loginInput {
    width: 100%;
    margin-bottom: 20px;
    padding: 12px 41px;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    background: none;
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    outline: none;
  }
  input::placeholder {
    color: #a7a7a7;
  }

  /* inputWrap */
  .inputWrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    label {
      display: flex;
      align-items: center;
    }
    input {
      width: 26px;
      height: 26px;
      margin-right: 14px;
      accent-color: #4dd2ae;
    }
    span {
      padding: 0;
      font-size: 20px;
      font-weight: 500;
      color: #a7a7a7;
    }
  }

  /* button */
  button {
    width: 100%;
    margin-top: 30px;
    padding: 14px;
    font-size: 28px;
    font-weight: 600;
    background: #4dd2ae;
    color: #fff;
    border-radius: 8px;
  }

  .qrCodeImage {
    margin-top: 140px;
  }
`;
